export const newSx = {
    input: {
        height: { xs: '30px', lg: '21px', xl: '30px' },
        fontSize: { lg: '10px', xl: '15px' }
    },
    label: {
        fontSize: { lg: '13px', xl: '15px' }
    }
}

export const paperSx = {
    backgroundColor: '#D9D9D9',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    height: '100%',
    overflowY: 'scroll'
}

export const lineSx = {
    display: 'flex',
    justifyContent: 'space-around',
    gap: '10px'
}

export const formGroupSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // width: '100%',
    gap: '3px'
}

export const formGroupInput = {
    width: '100%'
}
